import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './round-progress-bar.magic.css.js';
import script from './round-progress-bar.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"round-progress-bar",class:{ 'is-complete': _vm.isComplete },style:(_vm.styles),attrs:{"transform":"rotate(-90)","part":_vm.$p('round-progress-bar', { 'is-complete': _vm.isComplete })}},[_c('linearGradient',{attrs:{"id":"round-progress-bar-gradient"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"var(--magic-round-progress-bar-fill-color-to, var(--_round-progress-bar-fill-color-to))"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"var(--magic-round-progress-bar-fill-color-from, var(--_round-progress-bar-fill-color-from))"}})],1),_vm._v(" "),_c('circle',{staticClass:"track",attrs:{"part":"track","r":"50%","cx":"50%","cy":"50%"}}),_vm._v(" "),_c('circle',{staticClass:"fill",attrs:{"part":"fill","r":"50%","cx":"50%","cy":"50%"}})],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-340b0996_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
